<lib-filters-component [filters_options]="filter_service.filtersType"></lib-filters-component>

<app-wa-table [isSortableFunc]="sortClass" [showCondition]="true" [headers]="headers" [isDataLoading]="loading"
  [areMoreData]="areMoreData()" (loadMore)="loadMore()" [data]="data" (headerClick)="changeSort($event)" [extraClass]="['table-mobile-column']">
  <ng-template app-column let-interpretation [extraClass]="['wa-table__cell--fit-right']"><span class="nowrap">{{interpretation.effective | date : 'd MMM y'}}</span></ng-template>
  <!--<ng-template app-column let-interpretation><span class="nowrap">{{interpretation.approved | date : 'd MMM y'}}</span></ng-template>-->
  <ng-template app-column let-interpretation><h2>{{interpretation.title}}</h2></ng-template>
    <ng-template app-column let-interpretation>
    <p >{{interpretation.committee}}</p>
  </ng-template>
  <ng-template app-column let-interpretation>
    <a *ngFor="let article of interpretation.articles" routerLink="/rulebook/article/{{article.id}}" class="interpretation__related">{{processParam(article.title)}}</a>
  </ng-template>

  <ng-template app-column let-interpretation>
    <div class="list-row-item__action">
      <div *ngIf="interpretation?.documents[0]?.link" class="download">
        <a [href]="interpretation?.documents[0]?.link"></a>
      </div>
    </div>
  </ng-template>

  <ng-template app-column let-interpretation [extraClass]="['wa-table__cell--fit-left']">
    <div class="list-row-item__action" *ngIf="{data:data, showDetails:false} as detail" (click)="onClick(interpretation.index)">
      <span class="plus-minus {{isIndexSelected(interpretation.index) === false ? 'plus-minus--more' : 'plus-minus--less' }}">
      </span>
    </div>
  </ng-template>

  <ng-template app-row let-interpretation>
    <td colspan="100%" class="wa-table__cell wa-table__cell--fit">
      <div *ngIf="isIndexSelected(interpretation.index) === true" [innerHtml]="interpretation.content" class="wa-table-details"></div>
    </td>
  </ng-template>


  <ng-template [extraClass]="['td-100']" app-column-responsive let-interpretation>
    <div>
      <h2 class="info-header">{{interpretation.title}}</h2>
      <div>
        {{'Effective' | transloco}}: <span>{{interpretation.effective | date : 'd MMM y'}}</span>
      </div>
      <div>
        {{'Approved By' | transloco}}: <span>{{interpretation.committee}}</span>
      </div>
      <div>
        {{'Linked rules' | transloco}}:  <a *ngFor="let article of interpretation.articles" routerLink="/rulebook/article/{{article.id}}" class="interpretation__related">{{processParam(article.title)}}</a>
      </div>
      <div>
        <div *ngIf="interpretation?.documents[0]?.link" class="download download__mobile">
          <a [href]="interpretation?.documents[0]?.link"></a>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template app-column-responsive let-interpretation>
    <div class="list-row-item__action" *ngIf="{data:data, showDetails:false} as detail" (click)="onClick(interpretation.index)">
      <span class="plus-minus {{isIndexSelected(interpretation.index) === false ? 'plus-minus--more' : 'plus-minus--less' }}">
      </span>
    </div>
  </ng-template>
</app-wa-table>
